module.exports = __webpack_public_path__ + "static/img/logo.c5b4dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 4